"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackInAnalytics = void 0;
var config_1 = require("./config");
var tracker_1 = require("./tracker");
exports.trackInAnalytics = function (eventType, payload) {
    var eventData = config_1.getAnalyticsConfig()[eventType];
    if (!eventData) {
        console.error('Такого ключа в конфиге не существует', config_1.getAnalyticsConfig());
        return;
    }
    if (typeof window !== 'undefined' && typeof window.sp === 'function') {
        var dimensions = void 0;
        var label = eventData.label, action = eventData.action, category = eventData.category, deviceScreenName = eventData.deviceScreenName, dimensionsMapping_1 = eventData.dimensions;
        if (payload && dimensionsMapping_1) {
            var additionalDataKeys_1 = Object.keys(payload);
            dimensions = Object.keys(dimensionsMapping_1).reduce(function (obj, key) {
                var dimensionLevel = dimensionsMapping_1[key];
                if (additionalDataKeys_1.includes(key)) {
                    // eslint-disable-next-line no-param-reassign
                    obj[dimensionLevel] = payload[key];
                }
                return obj;
            }, {});
        }
        var screenName = deviceScreenName && { name: deviceScreenName };
        var contextList = [
            {
                schema: 'iglu:com.alfabank/custom_dimension/jsonschema/1-0-0',
                data: dimensions,
            },
            {
                schema: 'iglu:com.snowplowanalytics.snowplow/screen_view/jsonschema/1-0-0',
                data: screenName,
            },
        ];
        var filteredContextList = contextList.filter(function (context) { return !!context.data; });
        window.sp("trackStructEvent:" + tracker_1.getTrackerName(), category, action, label, null, null, filteredContextList);
    }
};

//# sourceMappingURL=action.js.map
